import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DateRange } from '@mui/lab/DateRangePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import jaLocale from 'date-fns/locale/ja';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useHistory, useLocation } from "react-router-dom";
import * as yup from 'yup';
import { API_URL, LICENSE_LIST } from "../../Const";
import ConfirmDialog from "../Dialog";
import GenericTemplate from "../templates/GenericTemplate";
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

const useStyles = makeStyles(() =>
  createStyles({
    datePicker: {
      width: '25ch',
    },
  })
);

// フォームの型
interface ConstructionUpdateFormInput {
  company_name: string,
  company_name_kana: string,
  total_user_count: string,
  total_capacity: string,
  remarks: string
}

// バリデーションルール
const schema = yup.object({
  company_name: yup
    .string()
    .required('必須項目です'),
  company_name_kana: yup
    .string(),
  total_user_count: yup
    .string()
    .matches(/^[0-9]*$/, '数値を入力してください'),
  total_capacity: yup
    // .number()
    .string()
    .matches(/^[0-9]*$/, '数値を入力してください'),
  remarks: yup
    .string()
})

const ConstructionEdit: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  /*データ取得*/
  const { state } = useLocation();
  const company_id = (state as any)?.company_id;
  const s_company_name = (state as any)?.company_name;
  let s_company_name_kana = ""
  s_company_name_kana = (state as any)?.company_name_kana;
  const contract_type = (state as any)?.contract_type;
  const s_from_date = (state as any)?.from_date;
  const s_to_date = (state as any)?.to_date;
  let s_total_user_count = "0"
  s_total_user_count = (state as any)?.total_user_count;
  const s_total_capacity = (state as any)?.total_capacity;
  const is_active = (state as any)?.is_active;
  const s_remarks = (state as any)?.remarks;
  const s_contract_id = (state as any)?.contract_id;


  /*送信パラメータ*/
  // const [company_id, setCompanyId] = useState('');
  const [company_name, setCompanyName] = useState(s_company_name);
  const [company_name_kana, setCompanyNameKana] = useState(s_company_name_kana);
  // const [contract_type, setContractType] = useState(s_contract_type);
  const [from_date, setFromDate] = useState(s_from_date);
  const [to_date, setToDate] = useState(s_to_date);
  const [total_user_count, setTotalUserCount] = useState(s_total_user_count);
  const [total_capacity, setTotalCapacity] = useState(s_total_capacity);
  // const [is_active, setIsActive] = useState(s_is_active);
  const [remarks, setRemarks] = useState(s_remarks);
  const [contract_id, setContractId] = useState(s_contract_id);




  const [value, setValue] = React.useState<DateRange<Date>>([s_from_date, s_to_date]);
  const [userPosts, setUserPosts] = useState([{ user_id: "" }])
  const [constructionPosts, setConstructionPosts] = useState([{ construction_id: "" }])
  const [is_active_val, setIsActive] = useState(is_active)
  const [contract_type_val, setContractType] = useState(contract_type)

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  const history = useHistory();






  /* 送信パラメータ値設定 */
  // const changeCompanyId = (e:any) => {
  //   setCompanyId(e.target.value)
  // }
  const changeCompanyName = (e: any) => {
    setCompanyName(e.target.value)
  }
  const changeCompanyNameKana = (e: any) => {
    setCompanyNameKana(e.target.value)
  }
  const changeContractType = (e: any) => {
    setContractType(e.target.value)
  }
  const changeFromDate = (e: any) => {
    setFromDate(e.target.value)
  }
  const changeToDate = (e: any) => {
    setToDate(e.target.value)
  }
  const changeTotalUserCount = (e: any) => {
    setTotalUserCount(e.target.value)
  }
  const changeTotalCapacity = (e: any) => {
    setTotalCapacity(e.target.value)
  }
  const changeIsActive = (e: any) => {
    setIsActive(e.target.value)
  }
  const changeRemarks = (e: any) => {
    setRemarks(e.target.value)
  }


  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ConstructionUpdateFormInput>({
    resolver: yupResolver(schema),
  })






  useEffect(() => {
    // 遅いので読み込みは詳細画面から受けとったデータを使用する
    // axios.post(API_URL.COMPANY_GET, 
    // {
    //   "company_id":company_id
    // },
    // { headers: { Authorization: jsonlist.token.IdToken} },
    // )
    // .then(res => {
    //   const company = res.data.data;
    //   setPosts(company)
    //   // console.log(posts)
    // })
    // .catch(error => {
    //   console.log(error)
    //   let jsonObject = JSON.parse(error);
    // });

    openLoading()
    // 企業内ユーザー取得
    axios.post(API_URL.USER_LIST,
      {
        "company_id": company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        const persons = res.data.data;
        setUserPosts(persons)

      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

    // 企業内工事取得
    axios.post(API_URL.CONSTRUCTION_LIST,
      {
        "company_id": company_id,
        "dealer_info_id": company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        const construction = res.data.data;
        setConstructionPosts(construction)

      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }, []);


  // 適切な形式で容量を表示
  const capacity = ({ val }: { val: string }) => {
    console.log('val:', val)
    const size = Number(val)
    console.log('capacity=', size)
    const gb = 1024000000
    // 表示単位はGB固定とし、小数点第二位まで表示
    const capacity_val = Math.floor((size / gb) * 100) / 100
    return capacity_val // + ' ' + 'GB'
  }

  // 利用停止文字列
  const active_state = ({ val }: { val: string }) => {
    if (val == "1") {
      return false
    } else {
      return true
    }
  }

  // 工事データから利用容量を産出
  const sumFileSize = () => {
    let subtotal = 0
    constructionPosts.forEach(item => {
      let size = (item as any)?.storage_size
      if (!isNaN(size)) {
        subtotal += parseInt(size)
      }
    })
    return subtotal.toString()
  }

  // 更新ボタン押下時の処理
  const onSubmit: SubmitHandler<ConstructionUpdateFormInput> = (data) => {
    handleClickOpenEdit()
  }

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理(キャンセル)*/
  const [openCancel, setOpenCancel] = React.useState(false);
  const handleClickOpenCancel = () => {
    setOpenCancel(true);
  };
  const gotoDetail = () => {
    // 詳細に戻る
    history.push({ pathname: "/CorporateDetail", state: { company_id: company_id, company_name: company_name, company_name_kana: company_name_kana, contract_type: contract_type, from_date: from_date, to_date: to_date, total_user_count: total_user_count, total_capacity: total_capacity, is_active: is_active, remarks: remarks } })
  };
  const setConfirmOpenCancel = (check: any) => {
    setOpenCancel(check)
  };
  /*ダイアログ処理(キャンセル)*/

  /*ダイアログ処理(更新)*/
  const [openEdit, setOpenEdit] = React.useState(false);
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };
  const editCompany = () => {
    if (!loading) {
      setLoading(true);
    }

    const param = {
      "company_id": company_id,
      "company_name": company_name,
      "company_name_kana": company_name_kana,
      "contract_type": contract_type_val,
      "total_capacity": total_capacity,
      "total_user_count": total_user_count,
      "from_date": value[0] ? moment(value[0]).format('yyyy/MM/DD') : from_date,
      "to_date": value[1] ? moment(value[1]).format('yyyy/MM/DD') : to_date,
      "is_active": is_active_val,
      "remarks": remarks,
      "contract_id": contract_id
    }
    console.log('param:', param)

    openLoading()
    axios.post(API_URL.COMPANY_UPDATE,
      param,
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        // 詳細に戻る
        console.log(res);
        history.push({ pathname: "/CorporateDetail", state: param });
      })
      .catch(error => {
        console.log('error:', error)
        console.log('error:', error.errMessage)
        setLoading(false);
      })
      .finally(() => {
        closeLoading()
      })

  };
  const setConfirmOpenEdit = (check: any) => {
    setOpenEdit(check)
  };
  /*ダイアログ処理(追加)*/

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('contract_type:', event.target.value)
    setContractType(event.target.value);
  };

  // チェックボックスクリック時のイベント
  const clickCheckbox = (event: any) => {
    // ここでis_activeを反転
    console.log('check:', event.target.checked)
    if (event.target.checked == true) {
      setIsActive('0')
    } else {
      setIsActive('1')
    }
  };


  // 画面表示用
  return (

    <GenericTemplate title="契約企業 編集">
      <Stack spacing={3} margin={2}></Stack>

      <div>
        <ConfirmDialog
          title="入力されているデータで更新しますか？"
          open={openEdit}
          setOpen={setConfirmOpenEdit}
          onConfirm={handleSubmit(editCompany)}
          loading={loading}
        >
          更新後詳細画面へ戻ります
        </ConfirmDialog>
      </div>

      <div>
        <ConfirmDialog
          title="詳細に戻りますか？"
          open={openCancel}
          setOpen={setConfirmOpenCancel}
          onConfirm={gotoDetail}
          loading={loading}
        >
          変更したデータは破棄されます
        </ConfirmDialog>
      </div>


      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業ID</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={company_id}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              defaultValue={company_name}
              type="string"
              {...register('company_name')}
              error={'company_name' in errors}
              helperText={errors.company_name?.message}
              onChange={changeCompanyName}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名カナ</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              defaultValue={company_name_kana}
              type="string"
              {...register('company_name_kana')}
              error={'company_name_kana' in errors}
              helperText={errors.company_name_kana?.message}
              onChange={changeCompanyNameKana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約形態</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            {/* <TextField
                value={LICENSE[contract_type]}
              /> */}
            <TextField
              required
              id="outlined-select-currency-native"
              select
              label="プラン選択"
              value={contract_type_val}
              onChange={handleChange}
              SelectProps={{
                native: true,
              }}
              className="InsText2"
              variant="outlined"
            >
              {LICENSE_LIST.map((option, index) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約期間</Grid>
          <Grid item xs={10}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
              <MobileDateRangePicker
                startText={from_date}
                endText={to_date}
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <React.Fragment>
                    <TextField {...startProps} value={from_date} />
                    <Box sx={{ mx: 2 }}> 〜 </Box>
                    <TextField {...endProps} value={to_date} />
                  </React.Fragment>
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Stack>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大ユーザー数</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              className="small-text"
              defaultValue={total_user_count}
              {...register('total_user_count')}
              error={'total_user_count' in errors}
              helperText={errors.total_user_count?.message}

              onChange={changeTotalUserCount}
            />
          </Grid>
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">利用ユーザー数</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={userPosts.length}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大容量(GB)</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              className="small-text"
              defaultValue={total_capacity}
              {...register('total_capacity')}
              error={'total_capacity' in errors}
              helperText={errors.total_capacity?.message}
              onChange={changeTotalCapacity}
            />
          </Grid>
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">利用容量</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={capacity({ val: sumFileSize() }) + ' GB'}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">利用停止</Grid>
          <Checkbox
            checked={active_state({ val: is_active_val })}
            onChange={clickCheckbox}
            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
          />
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              className="large-text"
              multiline
              defaultValue={remarks}
              onChange={changeRemarks}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>

      {/* 下部ボタンエリア */}
      <Stack spacing={0} margin={0}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={10}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              // onClick={handleClickOpenAdd}
              onClick={handleSubmit(onSubmit)}
            >
              更新
            </Button>
          </Grid>
          <Grid item={true} sm={5} md={6} xs={10}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              onClick={handleClickOpenCancel}
            >
              キャンセル
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </GenericTemplate>
  );
};

export default ConstructionEdit;